export default () => {
	//ADD MICRO MODAL CODE HERE. Check "src/patterns/02-molecules/modal" how to do
};
